(function() {
  define('bazemont/shared/selectYear',['angular'], function() {
    'use strict';
    return angular.module('bazemontSelectYear', []).component('bazemontSelectYear', {
      templateUrl: '/assets/javascripts/bazemont/shared/selectYear.html',
      bindings: {
        listUrl: '@',
        redirectUrl: '@',
        year: '@',
        blankLabel: '@'
      },
      controller: [
        '$http', '$window', function($http, $window) {
          var vm;
          vm = this;
          vm.$onInit = function() {
            return $http.get(vm.listUrl).then(function(response) {
              vm.options = response.data;
              return vm.selectedYear = vm.options[vm.options.indexOf(parseInt(vm.year))];
            });
          };
          vm.changeYear = function() {
            var url;
            url = vm.redirectUrl;
            if (vm.selectedYear) {
              url += '/' + vm.selectedYear;
            }
            return $window.location.href = url;
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=selectYear.js.map
;
